import React from 'react';

interface ProgressBarProps {
  progress: number;
  height?: number;
  marginTop?: string | number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  height = 4,
  marginTop = 2,
}) => {
  return (
    <div
      style={{
        width: '100%',
        height: `${height}px`,
        background: 'rgba(255,255,255,0.1)',
        borderRadius: `${height / 2}px`,
        overflow: 'hidden',
        marginTop: typeof marginTop === 'number' ? `${marginTop}px` : marginTop,
      }}
    >
      <div
        style={{
          width: `${progress || 0}%`,
          height: '100%',
          background: 'linear-gradient(90deg, #ff385c, #ff7a00)',
          transition: 'width 0.5s ease',
          borderRadius: `${height / 2}px`,
        }}
      />
    </div>
  );
};
